(function() {
  function initSwipe(gallery) {
    if (gallery.dataset.swipeInit) return;
    gallery.dataset.swipeInit = '1';

    const imgs = gallery.querySelectorAll('.card-swipe-img');
    const dots = gallery.querySelectorAll('.card-swipe-dot');
    if (imgs.length < 2) return;

    let current = 0, startX = 0, isDragging = false;

    function goTo(index) {
      imgs[current].classList.remove('card-swipe-img--active');
      dots[current]?.classList.remove('card-swipe-dot--active');
      current = (index + imgs.length) % imgs.length;
      imgs[current].classList.add('card-swipe-img--active');
      dots[current]?.classList.add('card-swipe-dot--active');
    }

    gallery.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    gallery.addEventListener('touchend', e => {
      if (!isDragging) return;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 30) goTo(diff > 0 ? current + 1 : current - 1);
      isDragging = false;
    }, { passive: true });
  }

  function initAll() {
    document.querySelectorAll('.card-swipe-gallery').forEach(initSwipe);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  const observer = new MutationObserver(initAll);
  observer.observe(document.body, { childList: true, subtree: true });
})();
